import { render, staticRenderFns } from "./NewVideoCheckData.vue?vue&type=template&id=6136d889&"
import script from "./NewVideoCheckData.vue?vue&type=script&lang=js&"
export * from "./NewVideoCheckData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports